import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';

// if (!localStorage.getItem('userId')) {
//   localStorage.setItem('userId', crypto.randomUUID());
// }

// if (!localStorage.getItem('domain')) {
//   localStorage.setItem('domain', 'localhost:5001/api');
// }

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    provideAnimations(),
    importProvidersFrom(NzModalModule, NzNotificationModule),
  ],
}).catch((err) => console.error(err));
